import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { BsFilter, BsChevronDown, BsChevronRight } from 'react-icons/bs';
import DemographyFilters from "./DemographyFilters";
import GeographyFilters from "./GeographyFilters";
import UserBehaviorFilters from "./UserBehaviorFilters";
import PartnerCategoryFilters from "./PartnerCategoryFilters";

// Single-context entrypoint to reduce prop surface
const AllPartnersFilters = ({ ctx }) => {
  const {
    selectedUser,
    showDefaultFilters,
    filterValues,
    onFilterChange,
    dynamicFilters,
    renderFilterContent,
    activeTab,
    handleTabClick,
    onUserChange,
    onAddAllPartnersFilter,
    onHideDefaultFilters,
    onSetSelectedUser,
    onResetAllFilters,
    onSetActiveTab,
    onSetShowDefaultFilters,
    onSetDynamicFilters,
  } = ctx || {};

  // State to track expanded sections
  const [expandedSections, setExpandedSections] = useState({
    UserBehavior: true,
    Geography: true,
    Demography: true,
    PartnerCategory: true
  });

  // Toggle section expansion
  const toggleSection = (sectionType) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionType]: !prev[sectionType]
    }));
  };

  // Read dropdown data directly from store
  const filter_dropdowns = useSelector(state => state.journey?.filter_dropdowns) || {};
  const region = filter_dropdowns?.geographic?.region || [];
  const state = filter_dropdowns?.geographic?.state || [];
  const city = filter_dropdowns?.geographic?.city || [];
  const campaigns = filter_dropdowns?.campaigns || [];
  const journeys = filter_dropdowns?.journey_list || [];
  const lists = filter_dropdowns?.autoemail_list || [];
  const campaign = filter_dropdowns?.campaign || [];
  const landingpage = filter_dropdowns?.landingpage || [];
  const features = filter_dropdowns?.features || [];
  const partnerCategories = filter_dropdowns?.partner_category || [];
  const handleDemographyChange = (field, value) => {
    onFilterChange && onFilterChange("Demography", field, value);
  };

  console.log("filterValues", journeys);
  const handleGeographyChange = (field, value) => {
    onFilterChange && onFilterChange("Geography", field, value);
  };
  const handleUserBehaviorChange = (field, value) => {
    onFilterChange && onFilterChange("UserBehavior", field, value);
  };
  const handlePartnerCategoryChange = (field, value) => {
    onFilterChange && onFilterChange("PartnerCategory", field, value);
  };
  const onTabClick = (tabName) => {
    handleTabClick && handleTabClick(tabName);
    if (selectedUser === "FilteredUsers" && Array.isArray(dynamicFilters) && !dynamicFilters.some(filter => filter.type === tabName)) {
      onAddAllPartnersFilter && onAddAllPartnersFilter(tabName);
      // Do not auto-hide default filters when adding a new tab filter
    }
  };

  const handleUserChangeInternal = (user) => {
    if (onSetSelectedUser) onSetSelectedUser(user);
    if (onResetAllFilters) onResetAllFilters();
    if (onSetActiveTab) onSetActiveTab("UserBehavior");
    if (onSetShowDefaultFilters) onSetShowDefaultFilters(false);

    if (
      user === "FilteredUsers" &&
      Array.isArray(dynamicFilters) &&
      dynamicFilters.length === 0 &&
      onSetDynamicFilters
    ) {
      const userBehaviorFilter = { id: Date.now(), type: "UserBehavior", name: "User Behavior", filters: {} };
      onSetDynamicFilters([userBehaviorFilter]);
    }
    // Optional back-compat callback
    if (onUserChange) onUserChange(user);
  };

  return (
    <div>
      <div className="mb-4 user-filter-section">
        <button
          className={`user-filter-toggle-btn ${selectedUser === "AllUsers" ? "active" : ""}`}
          onClick={() => handleUserChangeInternal("AllUsers")}
          type="button"
        >
          <span>All Users</span>
        </button>
        <span
          className={`filters-users-by-label ${selectedUser === "FilteredUsers" ? "active" : ""}`}
          onClick={() => handleUserChangeInternal("FilteredUsers")}
        >
          <BsFilter className="filter-icon" />
          <span>Filters users by</span>
        </span>
      </div>
      {selectedUser === "FilteredUsers" && (
        <div className="mb-3 ps-3">
          {/* All filter sections displayed by default with + icon */}
          {(() => {
            // Group filters by type
            const filterGroups = {
              UserBehavior: [],
              Geography: [],
              Demography: [],
              PartnerCategory: []
            };
            
            dynamicFilters.forEach((filter) => {
              if (filterGroups.hasOwnProperty(filter.type)) {
                filterGroups[filter.type].push(filter);
              }
            });

            // Filter type labels
            const filterTypeLabels = {
              UserBehavior: "User Behavior",
              Geography: "Geography",
              Demography: "Demography",
            //  PartnerCategory: "Partner Category"
            };

            // Order of filter types to display
          //  const filterTypeOrder = ["UserBehavior", "Geography", "Demography", "PartnerCategory"];
          const filterTypeOrder = ["UserBehavior", "Geography", "Demography"];
            return (
              <div className="filter-sections-wrapper">
                {filterTypeOrder.map((filterType) => {
                  const filtersOfType = filterGroups[filterType];
                  const count = filtersOfType.length;

                  const isExpanded = expandedSections[filterType];

                  return (
                    <div key={filterType} className="filter-section-container">
                      <div 
                        className="filter-section-header"
                        onClick={() => toggleSection(filterType)}
                      >
                        <div className="filter-section-title">
                          {isExpanded ? (
                            <BsChevronDown className="chevron-icon" />
                          ) : (
                            <BsChevronRight className="chevron-icon" />
                          )}
                          <span>{filterTypeLabels[filterType]}</span>
                          {count > 0 && (
                            <span className="filter-section-count">({count})</span>
                          )}
                        </div>
                        <button
                          className="filter-section-add-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            const newFilter = { 
                              id: Date.now(), 
                              type: filterType, 
                              name: filterTypeLabels[filterType], 
                              filters: {} 
                            };
                            onSetDynamicFilters && onSetDynamicFilters((prev) => [...prev, newFilter]);
                            // Expand section when adding a new filter
                            if (!isExpanded) {
                              toggleSection(filterType);
                            }
                          }}
                          type="button"
                        >
                          +
                        </button>
                      </div>
                      {isExpanded && (
                        <div className="filter-section-content">
                          {filtersOfType.map((filter) => (
                            <div key={filter.id} className="filter-row">
                              {renderFilterContent(filter.type, filter.id)}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>
      )}

      {/* All Users Content */}
      {selectedUser === "AllUsers" && (
        <div className="text-center py-4">
          <h5>All Users Selected</h5>
          <p className="text-muted">No additional filters applied. All users will be included.</p>
        </div>
      )}
    </div>
  );
};

export default AllPartnersFilters;

// Lightweight renderer for a single AllPartners filter type (no tabs/header)
export const RenderAllPartnersFilter = ({
  type,
  currentValues = {},
  onFilterChange,
  region,
  state,
  city,
  campaigns,
  journeys,
  lists,
  features,
  campaign,
  landingpage,
  partnerCategories
}) => {
  // Auto-read from store if not provided
  const filter_dropdowns = useSelector(state => state.journey?.filter_dropdowns) || {};
  const regionData = region ?? (filter_dropdowns?.geographic?.region || []);
  const stateData = state ?? (filter_dropdowns?.geographic?.state || []);
  const cityData = city ?? (filter_dropdowns?.geographic?.city || []);
  const campaignsData = campaigns ?? (filter_dropdowns?.campaigns || []);
  const journeysData = journeys ?? (filter_dropdowns?.journey_list || []);
  const listsData = lists ?? (filter_dropdowns?.autoemail_list || []);
  const campaignData = campaign ?? (filter_dropdowns?.campaign || []);
  const landingpageData = landingpage ?? (filter_dropdowns?.landingpage || []);
  const featuresData = features ?? (filter_dropdowns?.features || []);
  const partnerCategoriesData = partnerCategories ?? (filter_dropdowns?.partner_category || []);
  if (type === "Geography") {
    return (
      <GeographyFilters
        filterValues={currentValues}
        region={regionData}
        state={stateData}
        city={cityData}
        onFilterChange={(field, value) => onFilterChange && onFilterChange(field, value)}
      />
    );
  }
  if (type === "Demography") {
    return (
      <DemographyFilters
        filterValues={currentValues}
        onFilterChange={(field, value) => onFilterChange && onFilterChange(field, value)}
      />
    );
  }
  if (type === "UserBehavior") {
    return (
      <UserBehaviorFilters
        filterValues={currentValues}
        campaigns={campaignsData}
        journeys={journeysData}
        lists={listsData}
        features={featuresData}
        campaign={campaignData}
        landingpage={landingpageData}
        onFilterChange={(field, value) => onFilterChange && onFilterChange(field, value)}
      />
    );
  }
  if (type === "PartnerCategory") {
    return (
      <PartnerCategoryFilters
        filterValues={currentValues}
        partnerCategories={partnerCategoriesData}
        onFilterChange={(field, value) => onFilterChange && onFilterChange(field, value)}
      />
    );
  }
  return null;
};

// Build dynamic filters (Geography, Demography, UserBehavior) from API response
export function buildAllPartnersDynamicFilters(filtersFromApi = {}) {
  const nextDynamic = [];

  // Geographics → multiple rows
  if (Array.isArray(filtersFromApi.geographics)) {
    filtersFromApi.geographics.forEach((g, idx) => {
      const uiGeo = {
        hasDone: (g?.operator || '').toLowerCase() === 'does not contain' ? 'Does Not Contain' : 'Contains',
        zone: g?.zone || '',
        state: g?.state || '',
        city: g?.city || ''
      };
      nextDynamic.push({ id: Date.now() + idx, type: 'Geography', name: 'Geography', filters: uiGeo });
    });
  }

  // Demographics → group into multiple rows, preserving sequence
  if (Array.isArray(filtersFromApi.demographics) && filtersFromApi.demographics.length > 0) {
    let current = { age: '', gender: '', education: '' };
    const pushCurrentIfAny = () => {
      if (current.age || current.gender || current.education) {
        nextDynamic.push({ id: Date.now() + 2000 + nextDynamic.length, type: 'Demography', name: 'Demography', filters: { ...current } });
        current = { age: '', gender: '', education: '' };
      }
    };
    filtersFromApi.demographics.forEach(d => {
      if (!d) return;
      if (d.field === 'age') {
        // If age already set, start a new row
        if (current.age || current.gender || current.education) {
          pushCurrentIfAny();
        }
        if (Array.isArray(d.value) && d.value.length === 2) {
          current.age = `${d.value[0]}-${d.value[1]}`;
        } else if (typeof d.value === 'string' || typeof d.value === 'number') {
          current.age = String(d.value);
        }
      } else if (d.field === 'gender') {
        current.gender = d.value || '';
      } else if (d.field === 'education_level') {
        current.education = Array.isArray(d.value) ? (d.value[0] || '') : (d.value || '');
      }
    });
    // Push any remaining demographics group
    pushCurrentIfAny();
  }

  // Partner Category → one row per partner category entry
  if (Array.isArray(filtersFromApi.partner_category)) {
    filtersFromApi.partner_category.forEach((pc, idx) => {
      const operator = (pc?.operator || '').toLowerCase();
      const uiPC = {
        hasDone: operator === 'exclude' ? 'Exclude' : 'Include',
        partnerCategory: pc?.partner_category_id || pc?.id || '',
        allPartners: pc?.all_partners || 'All Partners'
      };
      // Ensure partnerCategory is a number to match dropdown values
      if (uiPC.partnerCategory) {
        uiPC.partnerCategory = Number(uiPC.partnerCategory);
      }
      nextDynamic.push({ id: Date.now() + 4000 + idx, type: 'PartnerCategory', name: 'Partner Category', filters: uiPC });
    });
  }

  // User behaviour → one row per behavior entry
  if (Array.isArray(filtersFromApi.user_behaviour)) {
    const actionToSpecificBehavior = {
      login: 'Login',
      got_leads: 'Got Leads',
      share: 'Share',
      imported_contacts: 'Imported Contacts',
      updated_profile: 'Updated Profile',
      created_tasks: 'Created Tasks',
      opened_notifications: 'Opened Notifications',
      clicked_links: 'Clicked Links (in Email/WhatsApp/Push)',
      completed_journey: 'Completed Actions / Journeys',
      inactive_users: 'Inactive Users',
      sync_contacts: 'Sync Contacts',
      contact_list: 'AutoEmail Contacts',
      // social_pages: 'Social Pages',
      // account_created_on: 'Account Created On'
    };

    filtersFromApi.user_behaviour.forEach((u, idx) => {
      const operator = (u?.operator || '').toLowerCase();
      const hasDone = operator === 'has not done' ? 'HasNotDone' : 'HasDone';

      const actionKey = (u?.action || '').toLowerCase();
      const specificBehavior = actionToSpecificBehavior[actionKey] || '';

      const condition = u?.condition || {};
      let behaviorAttribute = '';

      if (specificBehavior === 'Login') {
        if (condition.loggedin_no) behaviorAttribute = 'Number of times logged in';
        else if (condition.start_date || condition.end_date) behaviorAttribute = 'Last Login';
      } else if (specificBehavior === 'Updated Profile') {
        behaviorAttribute = 'Last Updated On';
      } else if (specificBehavior === 'Sync Contacts') {
        // Autofill the sub-filter with the method provided by API (e.g., "Gmail Contacts" or "Phonebook")
        behaviorAttribute = condition.method || '';
      } else if (specificBehavior === 'AutoEmail Contacts') {
        behaviorAttribute = 'Lists';
      } else {
        behaviorAttribute = '';
      }

      const uiUB = {
        hasDone,
        specificBehavior,
        behaviorAttribute,
        startDate: condition.start_date || '',
        endDate: condition.end_date || '',
        numberOfTimesLoggedIn: condition.loggedin_no || '',
        numberOfLeads: condition.number_of_leads || '',
        numberOfContacts: condition.number_of_contacts || '',
        contentType: condition.content_type ? condition.content_type.charAt(0).toUpperCase() + condition.content_type.slice(1) : '',
        numberOfShares: condition.number_of_shares || '',
        // Share-specific dates
        shareStartDate: condition.start_date || '',
        shareEndDate: condition.end_date || '',
        leadsStartDate: condition.start_date || '',
        leadsEndDate: condition.end_date || '',
        contactsStartDate: condition.start_date || '',
        contactsEndDate: condition.end_date || '',
        profileUpdatedStartDate: condition.start_date || '',
        profileUpdatedEndDate: condition.end_date || '',
        tasksStartDate: condition.start_date || '',
        tasksEndDate: condition.end_date || '',
        numberOfTasks: condition.number_of_tasks || '',
        numberOfOpens: condition.number_of_opens || '',
        notificationsStartDate: condition.start_date || '',
        notificationsEndDate: condition.end_date || '',
        numberOfClicks: condition.number_of_clicks || '',
        clickChannel: condition.channel || '',
        specificCampaign: condition.campaign || '',
        clicksStartDate: condition.start_date || '',
        clicksEndDate: condition.end_date || '',
        whichJourney: condition.journey_name || '',
        completionStartDate: condition.start_date || '',
        completionEndDate: condition.end_date || '',
        inactiveDays: condition.days_no_activity || '',
        syncOption: condition.method || '',
        selectedList: condition.list_name || '',
        featureDate: condition.date || '',
        // Social Pages - only set when action is social_pages
        selectedSocialPage: specificBehavior === 'Social Pages' ? (condition.social_page_id || '') : '',
        // Account Created On - only set when action is account_created_on
        accountCreatedStartDate: specificBehavior === 'Account Created On' ? (condition.start_date || '') : '',
        accountCreatedEndDate: specificBehavior === 'Account Created On' ? (condition.end_date || '') : ''
      };
      nextDynamic.push({ id: Date.now() + 3000 + idx, type: 'UserBehavior', name: 'User Behavior', filters: uiUB });
    });
  }

  return nextDynamic;
}

// Process user behavior filters for payload building
export function processUserBehaviorFilters(behaviorValues, payload) {

  console.log("behaviorValues", behaviorValues);
  console.log("payload", payload);
  if (!behaviorValues || Object.keys(behaviorValues).length === 0) return;
  const specificBehavior = behaviorValues.specificBehavior;
  const behaviorAttribute = behaviorValues.behaviorAttribute;
  if (!specificBehavior) return;

  let action = "";
  let condition = {};

  switch (specificBehavior) {
    case "Login":
      action = "login";
      if (behaviorAttribute === "Last Login") {
        if (behaviorValues.startDate) condition.start_date = behaviorValues.startDate;
        if (behaviorValues.endDate) condition.end_date = behaviorValues.endDate;
      } else if (behaviorAttribute === "Number of times logged in") {
        if (behaviorValues.numberOfTimesLoggedIn) condition.loggedin_no = behaviorValues.numberOfTimesLoggedIn;
        if (behaviorValues.startDate) condition.start_date = behaviorValues.startDate;
        if (behaviorValues.endDate) condition.end_date = behaviorValues.endDate;
      }
      break;
    case "Share":
        action = "share";
        if (behaviorValues.numberOfShares) condition.number_of_shares = behaviorValues.numberOfShares;
        if (behaviorValues.shareStartDate) condition.start_date = behaviorValues.shareStartDate;
        if (behaviorValues.shareEndDate) condition.end_date = behaviorValues.shareEndDate;
        if (behaviorValues.contentType) condition.content_type = behaviorValues.contentType.toLowerCase();
        break;

    case "Got Leads":
      action = "got_leads";
      if (behaviorValues.numberOfLeads) condition.number_of_leads = behaviorValues.numberOfLeads;
      if (behaviorValues.leadsStartDate) condition.start_date = behaviorValues.leadsStartDate;
      if (behaviorValues.leadsEndDate) condition.end_date = behaviorValues.leadsEndDate;
      break;

    case "Imported Contacts":
      action = "imported_contacts";
      if (behaviorValues.contactsStartDate) condition.start_date = behaviorValues.contactsStartDate;
      if (behaviorValues.contactsEndDate) condition.end_date = behaviorValues.contactsEndDate;
      if (behaviorValues.numberOfContacts) condition.number_of_contacts = behaviorValues.numberOfContacts;
      break;

    case "Updated Profile":
      action = "updated_profile";
      if (behaviorValues.profileUpdatedStartDate) condition.start_date = behaviorValues.profileUpdatedStartDate;
      if (behaviorValues.profileUpdatedEndDate) condition.end_date = behaviorValues.profileUpdatedEndDate;
      break;

    case "Created Tasks":
      action = "created_tasks";
      if (behaviorValues.numberOfTasks) condition.number_of_tasks = behaviorValues.numberOfTasks;
      if (behaviorValues.tasksStartDate) condition.start_date = behaviorValues.tasksStartDate;
      if (behaviorValues.tasksEndDate) condition.end_date = behaviorValues.tasksEndDate;
      break;

    case "Opened Notifications":
      action = "opened_notifications";
      if (behaviorValues.numberOfOpens) condition.number_of_opens = behaviorValues.numberOfOpens;
      if (behaviorValues.notificationsStartDate) condition.start_date = behaviorValues.notificationsStartDate;
      if (behaviorValues.notificationsEndDate) condition.end_date = behaviorValues.notificationsEndDate;
      break;

    case "Clicked Links (in Email/WhatsApp/Push)":
      action = "clicked_links";
      if (behaviorValues.numberOfClicks) condition.number_of_clicks = behaviorValues.numberOfClicks;
      if (behaviorValues.clickChannel) condition.channel = behaviorValues.clickChannel;
      if (behaviorValues.specificCampaign) condition.campaign = behaviorValues.specificCampaign;
      if (behaviorValues.clicksStartDate) condition.start_date = behaviorValues.clicksStartDate;
      if (behaviorValues.clicksEndDate) condition.end_date = behaviorValues.clicksEndDate;
      break;

    case "Completed Actions / Journeys":
      action = "completed_journey";
      if (behaviorValues.whichJourney) condition.journey_name = behaviorValues.whichJourney;
      if (behaviorValues.completionStartDate) condition.start_date = behaviorValues.completionStartDate;
      if (behaviorValues.completionEndDate) condition.end_date = behaviorValues.completionEndDate;
      break;

    case "Inactive Users":
      action = "inactive_users";
      if (behaviorValues.inactiveDays) condition.days_no_activity = behaviorValues.inactiveDays;
      break;

    case "Sync Contacts":
      action = "sync_contacts";
      if (behaviorAttribute) {
        condition.method = behaviorAttribute;
      } else {
        condition.method = "";
      }
      break;
      
    case "AutoEmail Contacts":
      action = "contact_list";
      condition.list_id = behaviorValues.selectedList || 0;
      
      break;

    case "Social Pages":
      action = "social_pages";
      if (behaviorValues.selectedSocialPage) {
        condition.social_page_id = behaviorValues.selectedSocialPage;
      }
      break;

    case "Account Created On":
      action = "account_created_on";
      if (behaviorValues.accountCreatedStartDate) condition.start_date = behaviorValues.accountCreatedStartDate;
      if (behaviorValues.accountCreatedEndDate) condition.end_date = behaviorValues.accountCreatedEndDate;
      break;

    default:
      action = "";
      break;
  }

  if (action && Object.keys(condition).length > 0) {
    const operator = behaviorValues.hasDone === "HasNotDone" ? "has not done" : "has done";
    payload.selectedfilters.user_behaviour.push({ operator, action, condition });
  }
}

// Process geography filters for payload building
export function processGeographyFilters(geoValues, payload) {
  if (geoValues && Object.keys(geoValues).length > 0) {
    const geoFilter = {
      operator: geoValues.hasDone?.toLowerCase() || "contains",
      zone: geoValues.zone || "",
      state: geoValues.state || "",
      city: geoValues.city || "",
    };
    if (geoFilter.zone || geoFilter.state || geoFilter.city) {
      payload.selectedfilters.geographics.push(geoFilter);
    }
  }
}

// Process demographics filters for payload building
export function processDemographicsFilters(demoValues, payload) {
  if (demoValues && Object.keys(demoValues).length > 0) {
    if (demoValues.age) {
      payload.selectedfilters.demographics.push({
        field: "age",
        operator: "has done",
        value: demoValues.age.split("-").map(Number),
      });
    }
    if (demoValues.gender) {
      payload.selectedfilters.demographics.push({
        field: "gender",
        operator: "has done",
        value: demoValues.gender,
      });
    }
    if (demoValues.education) {
      payload.selectedfilters.demographics.push({
        field: "education_level",
        operator: "has done",
        value: [demoValues.education],
      });
    }
  }
}

// Process partner category filters for payload building
export function processPartnerCategoryFilters(pcValues, payload) {
  if (pcValues && Object.keys(pcValues).length > 0) {
    if (!payload.selectedfilters.partner_category) {
      payload.selectedfilters.partner_category = [];
    }
    const partnerCategoryFilter = {
      operator: (pcValues.hasDone || "Include").toLowerCase(),
      partner_category_id: pcValues.partnerCategory || "",
    };
    if (partnerCategoryFilter.partner_category_id) {
      payload.selectedfilters.partner_category.push(partnerCategoryFilter);
    }
  }
}
